import * as jsxRuntime from "C:\\Pratik\\ET\\Frontend\\eido-under-development-page\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment